import { render, staticRenderFns } from "./DidNotRequestTempPassword.vue?vue&type=template&id=64b30faf&scoped=true&"
import script from "./DidNotRequestTempPassword.vue?vue&type=script&lang=js&"
export * from "./DidNotRequestTempPassword.vue?vue&type=script&lang=js&"
import style0 from "./DidNotRequestTempPassword.vue?vue&type=style&index=0&id=64b30faf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b30faf",
  null
  
)

export default component.exports